export default __webpack_public_path__ + "static/media/informIcon.c7fc638e.png";